// Styles
require("./guide.scss");

// Dependencies
var $ = require("jquery");
var cookies = require("utils/cookies-utils")

// Is Visible
function isVisible() {
    return cookies.read("guide-visible") !== null;
}

// Show
function show() {
    console.info("Hide guide with 'SHIFT + CTRL + ALT + G' shortcut.");
    cookies.create("guide-visible", "1", 30);

    var $guide = $('<div class="guide"></div>');
    $guide.appendTo($('body'));

    var $site = $('<div class="guide__site"></div>');
    $site.appendTo($guide);

    var $grid = $('<div class="guide__grid"></div>');
    for (var i = 1; i < 12; i++) {
        $grid.append('<div class="guide__grid-col"></div>');
    }
    $grid.appendTo($site);
};

// Hide
function hide() {
    cookies.create("guide-visible", "", -1);
    $('.guide').remove();
};

// Keyboard shorcut
// SHIFT + CTRL + ALT + G
var shortcut = function (e) {
    if (e.ctrlKey && e.shiftKey && e.altKey && e.keyCode == 71) {
        if (isVisible()) {
            hide();
        } else {
            show();
        }
    }
};
document.addEventListener('keyup', shortcut, false);

// Show if visible
if (isVisible()) {
    show();
}


// WEBPACK FOOTER //
// ./Sig.Web/src/common/com-guide/com-guide.chunk.js